import BaseService from './base/base.service'

export default class CheckoutService extends BaseService {

    constructor(){
        super('Checkout')
    }
}